import {NavLink, Outlet} from "react-router-dom";
import classNames from "classnames";
import "./AppLayout.scss"
import {useNavigate, useLocation} from "react-router-dom";
import dealydocs from "../../assets/dealydocs.png"
import Icon, {
    companyIcon,
    customerIcon,
    documentIcon,
    formsIcon, logoutIcon,
    sentIcon,
    settingsIcon,
    userIcon
} from "../Icon/Icon";
import Button from "../Button/Button";
import Avatar from "../Avatar/Avatar";
import useUser from "../../contexts/userContext/useUser";

const AppLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {user, role, logout} = useUser();

    const handleLogout = () => {
        logout();
        navigate("/");
    }

    const menuItems = [
        {
            path: "/users",
            label: "Users",
            iconFile: userIcon,
            allowedRoles: ["admin"]
        },
        {
            path: "/forms",
            label: "Forms",
            iconFile: formsIcon,
            allowedRoles: ["admin", "user"]
        },
        {
            path: "/clients",
            label: "Clients",
            iconFile: companyIcon,
            allowedRoles: ["superadmin"]
        },
        {
            path: "/customers",
            label: "Customers",
            iconFile: customerIcon,
            allowedRoles: ["admin", "user"]
        },
        {
            path: "/settings",
            label: "Settings",
            iconFile: settingsIcon,
            allowedRoles: ["admin"]
        },
        {
            path: "/sent-emails",
            label: "Sent Emails",
            iconFile: sentIcon,
            iconClassName: "sent",
            allowedRoles: ["admin", "superadmin"]
        },
        {
            path: "/documents",
            label: "Documents",
            iconFile: documentIcon,
            iconClassName: "documents",
            allowedRoles: ["user", "admin"]
        }
    ]

    return (
        <div className="app-layout">
            <nav className="menu">
                <img className="logo" src={dealydocs} alt="logo"/>
                {menuItems
                    .filter(item => item.allowedRoles.includes(role ?? "user"))
                    .map(item => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            className={({isActive}) => classNames("tab", {"active": isActive})}
                        >
                            <Icon svg={item.iconFile} className={classNames("tab-icon", item.iconClassName)}/>
                            {item.label}
                        </NavLink>
                    ))}

                <div className="bottom">
                    <Avatar
                        url={user?.image}
                        name={user?.name}
                        color={user?.color}
                        surname={user?.surname}
                        onClick={() => {
                            if (location.pathname !== '/users/profile') {
                                navigate('/users/profile', { state: { from: location.pathname }});
                            }
                        }}
                    />
                    <Button onClick={handleLogout} className="logout">
                        <Icon svg={logoutIcon}/>
                        Logout
                    </Button>
                </div>

            </nav>

            <div className="main">
                <Outlet />
            </div>
        </div>
    )
}

export default AppLayout;